import styled from 'styled-components'
import { textLinkWithHover } from '../../styles/textLink'

function ArticleInfo( { articleInfo, elementType = 'div' as 'div' | 'footer' | 'aside' } ) {
  const getInfo = info => {
    if ( typeof info === 'string' ) {
      return (
        <div 
          // eslint-disable-next-line react/no-danger
          dangerouslySetInnerHTML={ { __html: info } } 
        />
      )
    }

    return (
      <div>
        { info }
      </div>
    )
  }

  const Element = elementType

  return (
    <Element className="relative flex flex-col gap-4 leading-5.5">
      { articleInfo.map( item => (
        <div 
          className="flex flex-col *:flex *:flex-col *:gap-2 prose-with-links"
          key={ item.id }
        >
          { item.label && (
            <h2 className="text-red font-general-sans-semi-bold text-normal">{ item.label }</h2> 
          )}
          { getInfo( item.info ) }
        </div>
      ) ) }
    </Element>
  )
}

const StyledInfoItem = styled.div`
  margin-bottom: 1rem;
  line-height: 1.4;

  &:last-child {
    margin-bottom: 0;
  }

  h2 {
    margin: 0;
    ${ p => p.theme.typo.generalSansSemiBold }
    font-size: ${ p => p.theme.typo.sizes.normal };
    color: ${ p => p.theme.colors.red };
  }

  > div {
    > * {
      &:first-child {
        margin-top: 0;
      }
      
      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  a {
    color: inherit;
    ${ textLinkWithHover }
    text-decoration-color: ${ p => p.theme.colors.black };
  }

  .fu-c-partner-logo {
    width: 100%;
    max-width: 220px;
    max-height: 150px;
    margin-top: 0.66rem;
  }
`

export default ArticleInfo
